import { LucidePlus } from "lucide-react";
import React, { useState, useMemo, useEffect } from "react";
import NiSearch from "../../icons/ni-search";
import AddLocationModal from "../Modals/AddLocationModal";
import ManagementCard from "../Cards/ManagementCard";
import SearchSelect from "../SearchItems/SearchSelect";
import {
  addUser,
  getLeads,
  getUser,
  getUserRole,
} from "../../Redux/Slices/AppSlices";
import { useDispatch, useSelector } from "react-redux";
import Host from "../../Host/Host";
import axios from "axios";
import NiClosseye from "../../icons/ni-closseye";
import NiOpenEye from "../../icons/ni-openEye";
import Pagination from "../Pagination/Pagination";
import { Download, FileSpreadsheet, FileText } from "lucide-react";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import formatDate from "../DateFormate/DateFormate";
import logo from "../../Assets/Logo/logo-anokhi-home-green.png";
import CustomSelect from "../CustomSelect/CustomSelect";
import Loader from "../Loader/Loader";

const ITEMS_PER_PAGE = 15;
const STATUS_OPTIONS = ["new", "assigned", "unassigned", "converted", "lost"];

const DataTable = ({ data, mood, setAlert }) => {
  const dispatch = useDispatch();
  const { users } = useSelector((state) => state.app);
  const [customersList, setCustomersList] = useState([]);
  const [agentsList, setAgentsList] = useState([]);
  const [showNewCustomer, setShowNewCustomer] = useState(false);
  const [saving, setSaving] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  useEffect(() => {
    dispatch(getUser());
  }, [dispatch]);

  // console.log(users, "users");

  useEffect(() => {
    if (users?.length) {
      const customers = users.filter((user) => user.role === "user");
      const agents = users.filter((user) => user.role === "agent");
      setCustomersList(customers);
      setAgentsList(agents);
    }
  }, [users]);

  // console.log(customersList, "customersList");
  // console.log(agentsList, "agentsList");

  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [agentFilter, setAgentFilter] = useState("");
  const [dateFilter, setDateFilter] = useState("");
  const [page, setPage] = useState(1);
  const [open, setOpen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  // console.log(data,"data")
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const [selectedLead, setSelectedLead] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [formData, setFormData] = useState({
    customerId: "",
    name: "",
    phone: "",
    email: "",
    address: "",
  });

  useEffect(() => {
    if (selectedLead) {
      setFormData({
        customerId: selectedLead.customer || "",
        name: selectedLead.name || "",
        phone: selectedLead.phone || "",
        email: selectedLead.email || "",
      });

      // also set selectedCustomer for UI
      setSelectedCustomer({
        _id: selectedLead.customer,
        name: selectedLead.name,
        phone: selectedLead.phone,
        email: selectedLead.email,
      });
    }
  }, [selectedLead]);

  useEffect(() => {
    // console.log(formData, "Updated formdata");
  }, [formData]);

  // 🔥 FILTER LOGIC
  const filteredData = useMemo(() => {
    return (data || []).filter((lead) => {
      const matchesSearch =
        lead?.name?.toLowerCase().includes(search?.toLowerCase()) ||
        lead?.phone?.includes(search);
      const matchesStatus =
        statusFilter === "" || lead?.status === statusFilter;
      const matchesAgent = agentFilter === "" || lead?.agent === agentFilter;

      const leadDate = new Date(lead?.createdAt);
      const matchFrom = !fromDate || leadDate >= new Date(fromDate);
      const matchTo = !toDate || leadDate <= new Date(`${toDate}T23:59:59`);

      return (
        matchesSearch && matchesStatus && matchesAgent && matchFrom && matchTo
      );
    });
  }, [search, statusFilter, agentFilter, fromDate, toDate, data]);

  const sortedData = useMemo(() => {
    return [...filteredData].sort((a, b) => {
      const aNew = a?.status?.toLowerCase() === "new" ? 0 : 1;
      const bNew = b?.status?.toLowerCase() === "new" ? 0 : 1;
      if (aNew !== bNew) return aNew - bNew;
      return new Date(b?.createdAt) - new Date(a?.createdAt);
    });
  }, [filteredData]);

  // Pagination
  const totalPages = Math.ceil(sortedData.length / ITEMS_PER_PAGE);
  const paginatedData = sortedData.slice(
    (page - 1) * ITEMS_PER_PAGE,
    page * ITEMS_PER_PAGE,
  );

  const handleAddLead = async () => {
    const token = localStorage.getItem("token");
    // console.log(token, "token");
    // console.log("Adding lead:", formData);
    setSaving(true);
    try {
      const payload = {
        customerId: formData.customerId,
        name: formData.name,
        phone: formData.phone,
        email: formData.email,
      };
      const res = await axios.post(`${Host}/api/lead/add`, payload, {
        headers: {
          "auth-token": token,
          "Content-Type": "application/json",
        },
      });
      // console.log(res.data);
      setAlert({ message: "Lead added successfully!", status: "Success" });
      setTimeout(() => setAlert(null), 3000);
      setOpen(false);
      setFormData({
        customerId: "",
        name: "",
        phone: "",
        email: "",
        address: "",
      });
      dispatch(getLeads());
      setSaving(false);
    } catch (err) {
      console.error(err);
      setAlert({ message: "Failed to add lead", status: "Error" });
      setTimeout(() => setAlert(null), 5000);
      setSaving(false);
    } finally {
      setTimeout(() => setAlert(null), 5000);
      setSaving(false);
    }
  };
  const handleEditLead = async () => {
    try {
      setSaving(true);
      const token = localStorage.getItem("token");

      const res = await axios.put(
        `${Host}/api/lead/edit/${selectedLead._id}`,
        formData,
        {
          headers: {
            "auth-token": token,
            "Content-Type": "application/json",
          },
        },
      );

      dispatch(getLeads());
      setAlert({
        message: "Lead updated successfully",
        status: "Success",
      });
      setTimeout(() => setAlert(null), 5000);

      setSaving(false);
      setOpen(false);
    } catch (err) {
      console.error(err);
      setAlert({
        message: "Failed to update lead",
        status: "Error",
      });
      setTimeout(() => setAlert(null), 5000);
      setSaving(false);
    }
  };

  const handleAddCustomerAndLead = async () => {
    setSaving(true);
    try {
      // Create customer
      const result = await dispatch(
        addUser({
          name: formData.name,
          phone: formData.phone,
          email: formData.email,
          password: formData.password,
          address: formData.address,
          role: "user",
        }),
      ).unwrap();

      // Refresh users
      await dispatch(getUser());

      // Create lead using created customer id
      await axios.post(
        `${Host}/api/lead/add`,
        {
          customerId: result.user._id, // adjust according to your API
          name: formData.name,
          phone: formData.phone,
          email: formData.email,
          address: formData.address,
        },
        {
          headers: {
            "auth-token": localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        },
      );

      dispatch(getLeads());
      await dispatch(getUser());

      setFormData({
        customerId: "",
        name: "",
        phone: "",
        email: "",
        password: "",
      });

      setSelectedCustomer(null);
      setShowNewCustomer(false);
      setIsEditMode(false);
      setSelectedLead(null);

      setOpen(false);

      setAlert({
        message: "Customer & Lead created successfully",
        status: "Success",
      });
      setTimeout(() => setAlert(null), 5000);
      setSaving(false);
    } catch (err) {
      setAlert({
        message: err?.msg || "Failed",
        status: "Error",
      });
      setTimeout(() => setAlert(null), 5000);
      setSaving(false);
    }
  };

  const [exportOpen, setExportOpen] = useState(false);

  const EXPORT_COLUMNS = [
    "S.No",
    "Date",
    "Name",
    "Phone",
    "Email",
    "Status",
    "Associate",
  ];

  const capitalize = (str) => {
    if (!str) return "-";
    return str
      .toString()
      .toLowerCase()
      .replace(/\b\w/g, (l) => l.toUpperCase());
  };

  const getExportRows = () => {
    return (sortedData || []).map((lead, index) => ({
      "S.No": index + 1,
      Date: formatDate(lead?.createdAt) || "-",
      Name: lead?.name || "-",
      Phone: lead?.phone || "-",
      Email: lead?.email || "-",
      Status: capitalize(lead?.status),
      Associate: lead?.agent?.name,
    }));
  };

  /* =====================================================
   EXPORT EXCEL
===================================================== */
  const exportToExcel = () => {
    const rows = getExportRows();

    if (!rows.length) {
      setAlert({ message: "No lead data to export", status: "Error" });
      setTimeout(() => setAlert(null), 3000);
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(rows);

    const columnWidths = Object.keys(rows[0]).map((key) => {
      const maxLength = Math.max(
        key.length,
        ...rows.map((row) => String(row[key] ?? "").length),
      );
      return { wch: Math.min(maxLength + 3, 40) };
    });

    worksheet["!cols"] = columnWidths;

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Leads");

    XLSX.writeFile(workbook, "leads-report.xlsx");

    setAlert({ message: "Excel exported successfully", status: "Success" });
    setTimeout(() => setAlert(null), 3000);
    setExportOpen(false);
  };

  /* =====================================================
   EXPORT PDF
===================================================== */
  const loadLogo = (src) =>
    new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        canvas.getContext("2d").drawImage(img, 0, 0);
        resolve({
          data: canvas.toDataURL("image/png"),
          ratio: img.naturalWidth / img.naturalHeight,
        });
      };
      img.onerror = () => resolve(null); // export still works without the logo
      img.src = src;
    });

  const exportToPDF = async () => {
    const rows = getExportRows();

    if (!rows.length) {
      setAlert({ message: "No lead data to export", status: "Error" });
      setTimeout(() => setAlert(null), 3000);
      return;
    }

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    const logoImg = await loadLogo(logo);
    const LOGO_HEIGHT = 14; // mm
    const RIGHT_MARGIN = 5; // matches this table's right margin

    const drawLogo = () => {
      if (!logoImg) return;
      const w = LOGO_HEIGHT * logoImg.ratio; // keeps the aspect ratio
      const x = doc.internal.pageSize.getWidth() - RIGHT_MARGIN - w;
      doc.addImage(logoImg.data, "PNG", x, 6, w, LOGO_HEIGHT);
    };

    doc.setFontSize(18);
    doc.text("Leads Report", 14, 15);

    doc.setFontSize(9);
    doc.text(`Total Records: ${rows.length}`, 14, 22);

    const columns = Object.keys(rows[0]);
    const body = rows.map((row) => columns.map((column) => row[column] ?? "-"));

    const baseWidths = {
      "S.No": 8,
      Date: 18,
      Name: 26,
      Phone: 20,
      Email: 32,
      Status: 18,
      Associate: 26,
    };

    const margin = { top: 27, left: 8, right: 8, bottom: 10 };
    const pageWidth = doc.internal.pageSize.getWidth();
    const availableWidth = pageWidth - margin.left - margin.right;

    const totalBase = columns.reduce(
      (sum, col) => sum + (baseWidths[col] || 18),
      0,
    );
    const scale = availableWidth / totalBase;

    const columnStyles = {};
    columns.forEach((column, index) => {
      const base = baseWidths[column] || 18;
      columnStyles[index] = { cellWidth: base * scale };
    });

    autoTable(doc, {
      head: [columns],
      body,
      startY: margin.top,
      theme: "grid",
      tableWidth: "auto",
      styles: {
        fontSize: 8,
        cellPadding: 1.4,
        overflow: "linebreak",
        valign: "middle",
        halign: "left",
        lineWidth: 0.1,
      },
      headStyles: { fontSize: 8.5, fontStyle: "bold", valign: "middle" },
      bodyStyles: { valign: "middle" },
      columnStyles,
      margin,
      didDrawPage: drawLogo,
    });

    doc.save("leads-report.pdf");

    setAlert({ message: "PDF exported successfully", status: "Success" });
    setTimeout(() => setAlert(null), 3000);
    setExportOpen(false);
  };

  return (
    <div>
      <div className="filter-grid page-tools table-filters">
        {mood !== "user" && (
          <button
            className="add-button"
            onClick={() => {
              setSelectedLead(null);
              setSelectedCustomer(null);
              setShowNewCustomer(false);
              setIsEditMode(false);

              setFormData({
                customerId: "",
                name: "",
                phone: "",
                email: "",
                password: "",
              });

              setOpen(true);
            }}
          >
            <LucidePlus /> Add
          </button>
        )}
        {mood !== "user" && (
          <div className="searchItem">
            <NiSearch />
            <input
              placeholder="Search name / phone"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(1);
              }}
            />
          </div>
        )}
        {/* <div className="searchItem">
          <select
            value={statusFilter}
            onChange={(e) => {
              setStatusFilter(e.target.value);
              setPage(1);
            }}
          >
            <option value="">All Status</option>
            <option value="new">New</option>
            <option value="assigned">Assigned</option>
            <option value="unassigned">Unassigned</option>
            <option value="converted">Converted</option>
            <option value="lost">Lost</option>
          </select>
        </div> */}
        <CustomSelect
          className="cs-filter"
          value={statusFilter}
          onChange={(v) => {
            setStatusFilter(v);
            setPage(1);
          }}
          placeholder="All Status"
          options={[
            { value: "", label: "All Status" },
            ...STATUS_OPTIONS.map((s) => ({
              value: s,
              label: s.charAt(0).toUpperCase() + s.slice(1),
            })),
          ]}
        />

        <div className="searchItem">
          <label>From</label>
          <input
            type="date"
            value={fromDate}
            onChange={(e) => {
              setFromDate(e.target.value);
              setPage(1);
            }}
          />
        </div>

        <div className="searchItem">
          <label>To</label>
          <input
            type="date"
            value={toDate}
            onChange={(e) => {
              setToDate(e.target.value);
              setPage(1);
            }}
          />
        </div>
        <button className="add-button" onClick={() => setExportOpen(true)}>
          <Download size={18} />
          Export
        </button>
      </div>

      {paginatedData.length === 0 ? (
        <Loader />
      ) : (
        <div className="user-card-box">
          {paginatedData.map((item) => (
            <ManagementCard
              item={item}
              setSelectedLead={setSelectedLead}
              setIsEditMode={setIsEditMode}
              setOpen={setOpen}
              mood={mood}
              setAlert={setAlert}
              agentsList={agentsList}
            />
          ))}
        </div>
      )}
      <Pagination page={page} totalPages={totalPages} setPage={setPage} />
      <AddLocationModal
        open={open}
        onClose={() => setOpen(false)}
        title={isEditMode ? "Edit Lead" : "Add Lead"}
      >
        {showNewCustomer ? (
          <>
            <div className="field">
              <label>Name</label>
              <input
                value={formData.name || ""}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    name: e.target.value,
                  })
                }
              />
            </div>

            <div className="field">
              <label>Phone</label>
              <input
                value={formData.phone || ""}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    phone: e.target.value,
                  })
                }
              />
            </div>

            <div className="field">
              <label>Email</label>
              <input
                value={formData.email || ""}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    email: e.target.value,
                  })
                }
              />
            </div>

            {/* <div className="field">
              <label>Password</label>
              <input
                type="password"
                value={formData.password || ""}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    password: e.target.value,
                  })
                }
              />
            </div> */}
            <div className="field password-field">
              <label>Password</label>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={formData.password}
                onChange={(e) =>
                  setFormData({ ...formData, password: e.target.value })
                }
              />
              <span
                className="password-eye"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <NiClosseye /> : <NiOpenEye />}
              </span>
            </div>
            <div className="field">
              <label>Address</label>
              <input
                placeholder="Address"
                value={formData.address}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    address: e.target.value,
                  })
                }
              />
            </div>
          </>
        ) : (
          <>
            <div className="field">
              <SearchSelect
                label="Customer Name"
                placeholder="Search Customer by Name or Number"
                options={customersList}
                value={selectedCustomer}
                onChange={(selected) => {
                  setShowNewCustomer(false);
                  setSelectedCustomer(selected);
                  setFormData({
                    ...formData,
                    customerId: selected._id,
                    name: selected.name,
                    phone: selected.phone,
                    email: selected.email,
                  });
                }}
                displayKey="name"
                searchKeys={["name", "phone"]}
                renderOption={(c) => (
                  <div>
                    <b>{c.name}</b> ({c.phone})
                  </div>
                )}
                noResultComponent={
                  <div className="ss-item no-result">
                    <p>No customer found.</p>

                    <div className="modal-actions">
                      <button
                        type="button"
                        // className="add-button"
                        onClick={() => setShowNewCustomer(true)}
                      >
                        Add New Customer
                      </button>
                    </div>
                  </div>
                }
              />
            </div>
            <div className="field">
              <label>Phone</label>
              <input
                value={formData.phone}
                onChange={(e) =>
                  setFormData({ ...formData, phone: e.target.value })
                }
                placeholder="Phone Number"
              />
            </div>
            <div className="field">
              <label>Email</label>
              <input
                value={formData.email}
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
                placeholder="Email Address"
              />
            </div>
          </>
        )}

        <div className="modal-actions">
          <button
            disabled={saving}
            onClick={() => {
              if (showNewCustomer) {
                handleAddCustomerAndLead();
              } else if (isEditMode) {
                handleEditLead();
              } else {
                handleAddLead();
              }
            }}
          >
            {showNewCustomer
              ? "Create Customer & Lead"
              : isEditMode
                ? "Update Lead"
                : "Add Lead"}
          </button>
        </div>
      </AddLocationModal>
      <AddLocationModal
        open={exportOpen}
        onClose={() => setExportOpen(false)}
        title="Export Leads Report"
      >
        <div className="export-modal-body">
          <p style={{ fontSize: "0.85rem", marginBottom: "0.5rem" }}>
            This will export whatever is currently shown by the search, status
            and date filters ({sortedData?.length || 0} record
            {sortedData?.length === 1 ? "" : "s"}).
          </p>

          <div className="export-fields">
            <p>Export includes:</p>
            {EXPORT_COLUMNS.map((col) => (
              <span key={col}>{col}</span>
            ))}
          </div>
        </div>

        <div className="modal-actions" style={{ marginTop: "1rem" }}>
          <button
            type="button"
            className="export-excel-btn"
            onClick={exportToExcel}
          >
            <FileSpreadsheet size={18} />
            Excel
          </button>

          <button
            type="button"
            className="export-pdf-btn"
            onClick={exportToPDF}
          >
            <FileText size={18} />
            PDF
          </button>
        </div>
      </AddLocationModal>
    </div>
  );
};

export default DataTable;
